module.exports = __webpack_public_path__ + "media/img/Landing_Page/tutor-03-11980607e6aac40d568345a202780550.jpg";